<template>
  <div class>
    <h1 style="text-align: center;"><strong>用户服务协议</strong></h1>
<p style="text-align: right;"><strong><strong>编号：【】</strong></strong></p>
<p><strong><strong>&nbsp;</strong></strong></p>
<p style="text-align: right;">更新日期： &nbsp;&nbsp;&nbsp;年 &nbsp;月 &nbsp;日</p>
<p style="text-align: right;">生效日期： &nbsp;&nbsp;&nbsp;年 &nbsp;月 &nbsp;日</p>
<!-- <p>&nbsp; &nbsp; <strong>1.前言</strong></p> -->
<p>&nbsp; &nbsp; 本协议由用户与祺信平台（网址：pay.37cpep.com，以下简称“平台”）的运营方南阳商祺数贸科技有限公司（以下简称“运营方”，联系方式【4000377900】）订立，在用户与运营方之间具有与合同同等的法律效力。在用户正式使用平台功能前，请用户审慎阅读并选择接受或不接受本协议。用户理解并同意，用户委托的任何操作人员在平台进行的任何行为均为用户作出的真实意思表示，用户均予以承认并承担该操作人员行为的全部法律后果和法律责任。故本《用户服务协议》中并不区分用户行为与用户委托的操作人员的行为，均视为用户行为。</p>
<p>&nbsp; &nbsp; 当用户资料通过平台的认证审核，且用户选择“我已阅读、理解并同意《用户服务协议》”，则按照平台规定的注册程序成功注册为正式用户，用户的行为即表示同意并签署了本《用户服务协议》（以下简称“本协议”）。若用户不同意本协议，或对本协议的条款存在任何疑问，用户应停止进行平台用户注册程序。</p>
<p>&nbsp; &nbsp; 当用户资料通过平台的认证审核，且用户选择“我已阅读、理解并同意《用户服务协议》”，则按照平台规定的注册程序成功注册为正式用户，用户的行为即表示同意并签署了本《用户服务协议》（以下简称“本协议”）。若用户不同意本协议，或对本协议的条款存在任何疑问，用户应停止进行平台用户注册程序。</p>
<p>&nbsp; &nbsp; <strong>用户理解并同意，运营方有权基于业务功能、使用规则、法律法规及监管要求、更好地提供服务、经营策略等原因随时修改和（或）补充本协议条款和条件，并将之公示于平台，同时通过短信、邮件、平台公告、登录提示、操作提示等方式之一种或多种通知用户。用户可以在相关服务页面查阅最新版本的条款和条件。如果用户在协议条款和条件变更后使用平台时点击确认新版本协议，即视为用户已接受修改或补充后的协议。如果用户不同意运营方对本协议相关条款所做的修改和条件，原交易项下用户权利义务不变，但用户不得使用平台进行新的交易。</strong></p>

<p>&nbsp; &nbsp;<strong>第一条 释义</strong></p>
<p>&nbsp; &nbsp;1.1除本协议另有约定外，本协议中下列有关用语具有如下含义：</p>
<p>&nbsp; &nbsp;（1）祺信平台：指由南阳商祺数贸科技有限公司投资并运营的提供祺信相关信息服务的专业性网站（网址pay.37cpep.com），仅为用户提供查看、发布、处理交易信息等服务的科技平台。</p>
<p>&nbsp; &nbsp;（2）专属账户：指在运营方已在银行开立主账户的前提下，用户通过线下同意授权运营方通过银行为其开设的附属账户，用户在平台注册成为正式用户后，用户自动授权运营方在银行为用户开设账户，该账户对应用户平台账号。用户可以对该账户开展结算、查询等资金管理操作。</p>
<p>&nbsp; &nbsp;（3）用户：指接受并同意本协议及平台的业务规则，通过平台进行信息交互的平台企业注册用户以及通过双方系统直连方式与平台其他用户进行信息交互的用户。根据企业性质及业务定位不同，可分为买方（即应收账款债务人）、卖方（即应收账款债权人）和资金方。</p>
<p>&nbsp; &nbsp;（4）买方：指基础合同之购货方、接受服务方或其他基础合同项下应向卖方支付应收账款的付款人。</p>
<p>&nbsp; &nbsp;（5）卖方：指基础合同之销货方、提供服务方或其他基础合同项下债权人。</p>
<p>&nbsp; &nbsp;（6）基础合同：指卖方与买方签订的并约定采用赊销等信用销售方式进行的商品销售或服务合同或其他基础合同，根据该基础合同的约定，卖方享有要求买方到期支付应收账款的权利。</p>
<p>&nbsp; &nbsp;（7）资金方：平台所认可的，为平台用户提供融资服务的资金提供方，包括但不限于保理商及其他类型资金方。</p>
<p>&nbsp; &nbsp;（8）保理服务：指卖方或祺信持有人将其针对买方享有的应收账款转让给保理商，由保理商为其提供应收账款融资、应收账款管理、应收账款催收、信用风险担保等单项或多项的综合性服务。</p>
<p>&nbsp; &nbsp;（9）正向保理：保理商与卖方或祺信持有人直接开展商业保理业务合作，为其提供商业保理服务的保理业务。</p>
<p>&nbsp; &nbsp;（10）反向保理：保理商先与买方达成反向保理业务合作合意，由买方向保理商推荐卖方，后由保理商与卖方开展商业保理业务合作的保理业务。</p>
<p>&nbsp; &nbsp;（11）交易：用户之间进行的交易活动，形成交易关系，并通过平台与其他用户确认交易记录。</p>
<p>&nbsp; &nbsp;（12）业务规则和指引：指平台发布的届时有效的各项业务规则、操作流程、通知通告、使用说明和指引等文件，以及其不时被更新、替换、补充、修订的版本。就具体用户而言，对其有效的业务规则和指引包括根据法律、法规或本协议明确约定无需经其特别确认即可由平台规定的业务规则和指引，以及根据法律、法规或本协议明确约定需经其特别确认的业务规则和指引；就需经用户特别确认的业务规则和指引而言，在用户特别确认前，未经确认的业务规则和指引不对该具体用户生效。业务规则和指引应视为本协议重要的一部分。</p>
<p>&nbsp; &nbsp;（13）操作员：指用户通过向运营方出具授权委托书确定的业务经办人员（包括用户直接授权的管理员、管理员指定的经办员和复核员），代表用户在各自权限内进行注册、认证资料上传、账户开通、平台收支管理及回单打印、业务申请、业务资料上传和修改等账户管理、运作、维护事宜，其代表企业做出意思表示。<strong>运营方仅依据用户出具的授权委托书确认管理员主体，但不对包括管理员在内的操作员的身份、资格进行审核，针对用户确定的操作员，用户应保证其合法性、有效性及真实性。</strong>平台仅对操作员在平台上的所有操作进行记录，用于用户查询。</p>
<p>&nbsp; &nbsp;（14）管理员账户：指用户在成功注册为平台正式用户时获得的用户账户，用户指定管理员通过该用户账户登录平台并进行操作。该管理员账户一旦开立，在用户使用平台期间不得停用，但用户可向运营方提交新的授权文件以更换指定的管理员。<strong>维护密码及账号的机密安全，是用户的责任。用户应对所有使用管理员账户密码及账号的操作负完全的责任。</strong>经用户明确授权，管理员有权通过管理员账户开立、管理、停用"经办员账户"、"复核员账户"（统称"普通账户"），将用户授权给管理员的全部或部分事项交由经办员、复核员并通过其对应的普通账户办理，亦有权调整或停止普通账户的具体权限，且上述普通账户相关事项无需用户另行授权或确认。</p>
<p>&nbsp; &nbsp;（15）普通账户：指由管理员通过管理员账户在平台上开立的"经办员账户"、"复核员账户"，其对应的经办员、复核员由管理员指定，每个普通账户的具体权限由管理员通过管理员账户设置和维护。管理员可以将管理员账户设置为同时兼备"经办员账户"、"复核员账户"功能。<strong>维护密码及账号的机密安全，是用户的责任。用户应对所有使用普通账户密码及账号的操作负完全的责任。</strong></p>
<p>&nbsp; &nbsp;（16）祺信：指祺信开立方在平台上开立的《付款承诺函》项下的应付账款债务，所对应供应商的应收账款债权，该债权符合平台业务规则的可以进行划分，划分后的部分债权金额不低于0.01元。<strong>祺信仅是前述债权的电子化表现形式，仅能在有真实交易的平台注册用户间流转，其并不是《中华人民共和国票据法》规定的任一种类的票据，亦不是《中华人民共和国证券法》规定的任一种类的证券。祺信分为"不可变更祺信"、"可变更祺信"：不可变更祺信一经开立，其到期日不得更改；可变更祺信可在祺信记载的到期日前，由祺信开立方将到期日变更为早于祺信记载的到期日的日期（仅可变更一次）。</strong></p>
<p>&nbsp; &nbsp;（17）祺信开立方：指根据平台业务规则，具备开立祺信资格的买方。</p>
<p>&nbsp; &nbsp;（18）祺信持有方：指根据平台业务规则签收或受让祺信并持有祺信的用户。</p>
<p>&nbsp; &nbsp;（19）祺信开立日：指祺信开立方开立祺信给卖方的日期，该日期由平台系统记录并展示。</p>
<p>&nbsp; &nbsp;（20）祺信签收日/生效日：指卖方签收祺信的日期，祺信签收日为祺信生效日，由平台系统记录并展示。</p>
<p>&nbsp; &nbsp;（21）祺信到期日：一般指祺信载明的到期付款日，但就可变更祺信而言，若其到期日已经更改，则祺信到期日为平台记载的变更后的到期日。祺信到期日为《付款承诺函》项下应付账款的到期日。在祺信到期日之前（含），祺信开立方应将祺信载明款项转至其祺信付款账户，以便银行从中扣划资金至祺信持有方。</p>
<p>&nbsp; &nbsp;（22）祺信付款账户：指祺信开立方就祺信到期款项对外付款、自动授权平台在银行为用户开设的唯一付款账户。开立方未特别指定时，开立方的专属账户即为祺信付款账户。祺信开立方应在祺信到期日当日12:00之前将不少于承诺付款金额的资金转入祺信付款账户。祺信开立方委托平台在祺信到期日根据系统自动生成的《付款通知书》向银行发送划款指令，将祺信回款（即祺信开立方应转给祺信持有人的祺信到期应付款项）转至最终祺信持有方指定的账户。</p>
<p>&nbsp; &nbsp;（23）付款通知书：祺信到期日前10日，平台根据祺信最终持有人情况，自动向祺信开立方发出《付款通知书》，要求祺信开立方按期足额转入祺信应付账款金额。</p>
<p>&nbsp; &nbsp;（24）电子认证服务机构：指接受平台的委托，协助平台办理用户身份认证并为认证通过的用户签发电子签名认证证书的服务机构。</p>
<p>&nbsp; &nbsp;（25）电子签名：指《中华人民共和国电子签名法》所规定的电子签名，是指数据电文中以电子形式所含、所附用于识别签名人身份并表明签名人认可其中内容的数据。</p>
<p>&nbsp; &nbsp;（26）电子合同：指在平台运营过程中，用户使用电子认证服务机构颁发的与平台绑定的数字证书，在平台上通过点击确认等方式签署的数据电文，形式包括但不限于协议、授权委托书、保证函、单方确认等。用户通过前述方式订立的电子合同对合同各方具有法律约束力。</p>
<p>&nbsp; &nbsp;（27）账户余额：指用户专属账户内资金余额。根据用户是否可以自由提用，账户余额分为冻结资金与可提资金。冻结资金是指在平台上各方认可的业务规则下，特定情形中因业务需要而被平台系统冻结的资金。账户余额减去冻结资金为用户可提资金。</p>
<p>&nbsp; &nbsp;（28）税控安全认证工具：税控安全认证工具系运营方与合作第三方共同开发的用于平台用户身份认证、信息核对的软件工具。用户安装税控安全认证工具即表示同意该软件的用户许可协议及平台关于该软件的使用约定。</p>

<p>&nbsp; &nbsp;<strong>第二条 服务简介</strong></p>
<p>&nbsp; &nbsp;2.1平台首页域名为pay.37cpep.com（日后变更首页域名的，以变更后的为准）；平台通过网站及其他登录客户端为用户提供互联网信息服务。</p>
<p>&nbsp; &nbsp;2.2平台通过网站以及其他渠道和方式向用户提供以下信息的发布服务中的一项或多项：</p>
<p>&nbsp; &nbsp;（1）为用户之间的信息交互提供平台及服务系统；</p>
<p>&nbsp; &nbsp;（2）债权转让的信息传输；</p>
<p>&nbsp; &nbsp;（3）信用咨询及交易管理服务；</p>
<p>&nbsp; &nbsp;（4）其他相关服务。</p>
<p>&nbsp; &nbsp;2.3平台为用户提供祺信使用的相关服务，具体内容详见《祺信使用协议》。</p>
<p>&nbsp; &nbsp;2.4 平台为用户提供保理业务的信息交互相关服务，具体内容以相关业务协议为准。</p>
<p>&nbsp; &nbsp;2.5用户在平台成功注册为正式用户后，运营方通过银行为用户开立账户，该账户将成为用户的专属账户，用户对专属账户享有唯一使用权。在平台进行的所有资金的往来、结算、划拨均实际通过银行进行，该专属账户可为用户提供结算、查询等资金管理功能。<strong>用户通过平台进行上述操作，并在此不可撤销地授权运营方及平台按照本协议及其他已阅读并同意的平台业务规则向开户银行发出关于管理专属账户内资金的指令。</strong>开户银行保障用户专属账户中的资金安全，运营方在提供平台服务过程中保障平台系统安全。</p>
<p>&nbsp; &nbsp;该专属账户将于用户在平台注册的账户注销时自动关闭，关闭时专属账户余额资金将由用户通过平台结转。除另有协议明确约定外，专属账户内资金仅可在平台体系内的不同专属账户之间依据固定业务规则划转，或向平台体系外与用户同名的银行账户提现，或由资金方根据融资的要求授权平台向银行发送信息以便银行将融资款项从融资申请人专属账户向平台体系外非同名的银行账户转账。</p>
<p>&nbsp; &nbsp;2.6平台向用户提供电子合同的备份、查看、核对、下载等服务，如对电子合同真伪或电子合同的内容有任何疑问，用户可通过使用平台的查阅合同功能进行核对，或直接登录电子认证服务机构的官网查询、下载。除有相反证据证明外，平台系统所记录并在平台网页上显示的数据和信息是确定用户在平台操作具体内容的依据。</p>
<p>&nbsp; &nbsp;2.7<strong>为更好地提供用户服务，平台可能会委托相关合作方为用户提供一部分用户服务而无须经过用户的同意或特别告知用户；对此，用户完全理解并予以同意，同时除事先取得用户付费同意外，用户无需为此类委托支付任何额外费用。</strong></p>
<p>&nbsp; &nbsp;2.8用户应自行准备上网设备，包括但不限于计算机、调制解调器或其他必备的上网装置，并保证上网设备的安全性及自行承担上网开支，包括但不限于网络接入费、手机流量费等费用。</p>

<p>&nbsp; &nbsp;<strong>第三条 用户管理</strong></p>
<p>&nbsp; &nbsp;3.1<strong>平台只接受在中国（为本协议之目的，不包括香港特别行政区、澳门特别行政区及台湾地区）注册成立，且有权订立具有法律约束力协议的企业法人或其他经济组织成为正式用户。如果不符合前述条件，请勿注册平台用户。</strong></p>
<p>&nbsp; &nbsp;3.2<strong>用户申请成为平台用户时，应按照提示要求向平台提供真实、准确、完整、合法有效的注册及认证资料；当用户的注册资料发生变动时，应及时进行更新。</strong>如果涉及用户名称、统一社会信用代码、法定代表人和授权操作员的姓名及其身份证号码、资金交易密码等信息变动的，用户更新后，须经平台在3个工作日内审核后方可生效。<strong>用户应保证诸如电子邮件地址、联系电话、联系地址等内容的有效性及安全性。一旦平台及平台其他用户向用户注册资料中提供的地址、邮箱、联系电话发送通知即视为已向该用户送达。如果用户提供的注册资料不合法、不真实、不准确、不详尽、无效的，用户须承担因此引起的相应责任及后果，并且平台有权在发送注销通知30日后，注销用户账户（包括管理员账户、普通账户），终止用户使用平台服务的权利。如用户是通过取得邀请码并进行用户注册的，用户应确认并承诺所获得的邀请码是通过合法合规的方式取得，且该取得不存在对任何第三方的违约或侵权等情形。</strong></p>
<p>&nbsp; &nbsp;3.3在成功注册成为平台正式用户后，用户即获得其设置的平台账户（包括管理员账户、普通账户，以下统称"用户账户"），用户账户是用户登录平台的唯一账户。登录平台时，用户应当使用用户账户和用户设定并保管的密码进行登录。为保护用户的权益，用户在设定用户账户密码时，请使用符合平台要求的密码策略；平台为用户提供双重密码，用户可在用户账户下设定资金交易密码，进一步保障用户资金安全。<strong>用户应妥善保管用户的用户账户密码及资金交易密码，因密码保管不善而造成的经济损失由用户自行承担，平台对用户的用户账户和密码的遗失或被盗所产生的后果不承担任何责任。</strong>用户通过平台向数字证书服务机构申请电子签章数字证书并使用数字证书在平台签署电子合同。用户获得数字证书的下载凭证后，应妥善保管下载凭证，并在平台上操作使用数字证书，进行电子合同的签章。具体而言，用户同意使用北京中金国信科技有限公司提供的"安心签"电子合同平台服务，以及中金金融认证中心有限公司（简称"CFCA"）为"安心签"提供的第三方电子认证服务，用户同意向CFCA申请、绑定数字证书，并使用该等数字证书通过"安心签"平台签署电子合同。</p>
<p>&nbsp; &nbsp;3.4<strong>除企业指定并授权的操作员外，用户注册成功后，不得将平台的用户名转让给第三方或者授权给第三方使用。用户使用其自身的用户名和密码登录平台后在平台的一切行为均代表该用户并由该用户承担相应的法律后果。平台对用户的用户名和密码的遗失或被盗所产生的后果不承担任何责任。同时，如果用户的上述行为对平台系统造成损失的，用户对此承担全部的赔偿责任。</strong></p>
<p>&nbsp; &nbsp;3.5用户同意并认可平台可以通过系统消息、平台公告、邮件、短信（含平台委托的第三方短信服务）、电话等形式，向用户发送告知信息。</p>
<p>&nbsp; &nbsp;3.6系统直连用户与平台间的权利义务关系以双方另行签订的直连合作文件为准。系统直连用户与平台注册用户在平台上进行祺信相关操作时，受平台相关协议、双方签署的其他业务文件、平台规则和交易惯例的约束，并按以下顺序确认优先效力：双方签署的其他业务文件、平台相关协议、平台规则和交易惯例。</p>

<p>&nbsp; &nbsp;<strong>第四条 平台的基本使用规则</strong></p>
<p>&nbsp; &nbsp;4.1一旦用户注册成为平台用户或与平台进行系统直连，即表示用户已同意本协议及相关业务规则。</p>
<p>&nbsp; &nbsp;4.2用户通过在平台上输入其注册的用户名以及设定的密码进行登录或通过系统直连方式，并依照平台相关业务规则所规定的流程进行操作，<strong>用户一旦向平台发出指令，便不得撤回或撤销，且成为平台向用户提供有关交易服务的唯一指令。如用户需要撤销基于该等指令进行的操作的，用户需在平台功能允许且在该指令的相关方基于该等指令进行操作前，另行发出撤销操作的指令。</strong></p>
<p>&nbsp; &nbsp;4.3用户可以将其持有的债权在平台内向平台其他用户转让，<strong>具体业务内容由各方用户自行确定，平台仅提供信息服务和技术支持服务。平台对于用户之间业务的合法性、真实性不承担任何责任。</strong></p>
<p>&nbsp; &nbsp;4.4<strong><strong>平台与银行等金融机构合作为用户提供相关服务，但是，平台本身并不是银行等金融机构，平台向用户提供的服务也非金融业务，本协议项下的资金结算均通过银行来实现，用户理解并同意其资金在银行体系间流转需要合理时间，并按照银行公布的收费标准缴纳转账费用。</strong></strong></p>
<p>&nbsp; &nbsp;4.5用户同意，平台可通过银行或向第三方机构收集用户公开的相关资料，以核实用户身份、资产、信用等方面的真实状况。用户可授权平台在用户许可的信息渠道收集用户部分非公开信息。平台可向资金方及合作机构等披露相关信息，但仅可提供用户授权范围内的信息。如遇政府机关、监管机构需要提供资料，平台有权向用户收集相关资料并提供，用户理解并会予以配合。无论用户是否最终交易成功，平台均不承担因用户授权披露信息而产生的任何法律责任。</p>
<p>&nbsp; &nbsp;4.6 用户在导入/推送应收/应付账款时，可选择"ERP自动导入/推送"模式。若用户选择"ERP自动导入/推送"则表示用户授权平台自动采集其ERP系统（或其他进销存管理系统/财务系统/交易系统等）的业务信息。<strong>平台可向金融机构等资金方披露自动采集的业务信息，但仅可提供用户授权范围内的发票/业务信息。无论用户是否最终获得融资，平台均不承担因用户授权披露信息而产生的任何法律责任。</strong></p>
<p>&nbsp; &nbsp;4.7<strong>用户安装税控安全认证工具表示用户授权平台使用税控安全认证工具对身份及业务信息进行核正，以满足授信或融资的需求，平台可向金融机构等资金方披露该等信息。无论用户是否最终获得融资，平台均不承担因用户授权披露信息而产生的任何法律责任。</strong></p>
<p>&nbsp; &nbsp;4.8<strong>若用户未遵从本协议或相关业务规则，则平台有权拒绝为用户提供相关服务，由此产生的损害由用户自行承担。若发生上述状况，而相关款项已由平台其他用户先行划付至用户的专属账户名下，用户同意由平台协助平台其他用户向开户银行发出指令直接扣回相关款项或限制用户提取和使用此笔款项。若此笔款项已由用户通过平台划转至该用户专属账户外的银行账户，则平台有协助平台其他用户向用户事后索回之权利；因用户的原因导致平台协助平台其他用户进行事后追索的，用户应当承担合理的追索费用（包括诉讼费、律师费、差旅费、保全费等）。</strong></p>
<p>&nbsp; &nbsp;4.9<strong>因用户的过错导致的损失，应由用户自行承担责任，该过错包括但不限于：不按照本协议、平台的业务规则操作，未及时进行平台操作，遗忘或泄漏密码，密码被他人破解，用户使用的计算机被他人侵入等。</strong></p>
<p>&nbsp; &nbsp;4.10如平台发生了因系统故障或其他任何原因导致的处理错误，平台有权纠正该错误。<strong>如该错误导致用户实际收到/转出的款项与应获得/转出的金额不符的，用户同意无论错误的性质和原因为何，平台将纠正被不当执行的交易，用户应根据平台向用户发出的有关纠正错误的通知的具体要求进行操作。用户理解并同意，用户因前述处理错误而多收/多付或少收/少付的款项均不计利息。</strong></p>
<p>&nbsp; &nbsp;4.11<strong>平台所涉及到的任何款项只以人民币计结，平台不提供任何形式的汇兑业务。</strong></p>
<p>&nbsp; &nbsp;4.12<strong>用户在使用平台的过程中，本协议及相关业务规则共同构成平台的使用规则。若用户使用本协议或业务规则中所涉及的交易服务项目，即表示用户同意并接受各项已明示的业务规则所规定的相关内容。同时，平台有权单方修改本协议或各项业务规则，并以平台公告、系统通知、邮件通知、短信（含平台委托的第三方短信服务）、电话、登录提示、操作提示等方式之一种或多种通知用户，若用户不同意相关内容，则用户已开展的原交易项下用户权利义务不变，但用户应立即停止通过使用平台提供的相关交易服务和平台的有关功能进行新的交易。若用户点击并确认新的协议及业务规则，则视为用户同意并接受有关业务规则修改后的内容。</strong></p>
<p>&nbsp; &nbsp;4.13 用户应理解并同意在平台使用过程中，用户在平台上与其他用户签订的相关协议文本显示用户到期存在应付款项的，授权平台系统根据业务规则自动向银行发送相关信息以便银行划转用户专属账户中的资金，用于清偿用户的应付款项。</p>
<p>&nbsp; &nbsp;4.14用户授权平台进行资金信息的分类管理，将专属账户的账户余额分为冻结资金与可提资金。<strong>对于超出可提资金的用户划款指令，平台有权拒绝向银行发送该信息。用户应当按照相关协议文本的约定按时足额进行结算。若用户违约未履行或者未完全履行付款义务或者与其他用户有任何有关争议，平台不承担任何责任。</strong></p>
<p>&nbsp; &nbsp;<strong>第五条 服务费用</strong></p>
<p>&nbsp; &nbsp;<strong>5.1在用户接受平台提供的服务时，同意平台有权向用户收取相关服务费用，平台拥有制定及调整服务费用的权利。具体服务费用以用户使用平台提供的服务时，平台公示的收费标准或用户与平台达成的其他书面协议为准。</strong></p>
<p>&nbsp; &nbsp;<strong>5.2用户在使用平台服务过程中可能需要向第三方（如商业保理公司或银行等）支付一定的费用、利息，具体收取标准以第三方公示的收取标准或用户与第三方达成的其他书面协议为准。</strong></p>
<p>&nbsp; &nbsp;<strong>5.3除非另有说明或约定，用户同意平台向银行发出从用户专属账户中直接扣收上述款项的指令，实际扣收金额以用户确认的相关业务合同约定为准。</strong></p>

<p>&nbsp; &nbsp;<strong>第六条 平台的服务限制与服务终止</strong></p>
<p>&nbsp; &nbsp;<strong>6.1用户同意，平台可随时根据政策法规的变动，提前以短信（含平台委托的第三方短信服务）、邮件、平台公告等方式通知用户后，中断一项或多项服务，中断服务前，平台会为用户预留一定准备时间，除法律另有规定外，平台无义务对任何个人或第三方负责。</strong></p>
<p>&nbsp; &nbsp;<strong>6.2若用户违反本协议的约定，平台有权暂停或终止向用户提供服务。</strong></p>
<p>&nbsp; &nbsp;<strong>6.3在平台发现用户操作异常，或平台对用户的操作有疑问，或平台认为用户的操作有违反法律法规规定、本协议及相关业务规则时，平台可对用户采取特殊限制措施（包括但不限于对用户名下未完成的操作采取取消、纠正错误、暂停服务等），并通过网站公告或系统消息等形式通知用户。</strong></p>

<p>&nbsp; &nbsp;<strong>第七条 用户注销</strong></p>
<p>&nbsp; &nbsp;<strong>7.1如用户需要注销其在平台注册的管理员账户，应首先清偿所有应付款项（包括但不限于借款本金、利息、罚息、违约金、服务费、管理费、第三方费用等），再将用户账户中的可用款项（如有）全部提现至该用户专属账户外的同名银行账户，或者向平台发出其他合法的指令，并向平台申请注销该管理员账户，经平台审核同意后可正式注销。</strong></p>
<p>&nbsp; &nbsp;<strong>7.2平台注销该注册用户管理员账户，即表明平台与用户之间的服务协议已解除，但用户仍应对使用平台服务期间的行为承担可能的违约或损害赔偿责任，同时平台仍可保有用户的相关资料和交易数据。</strong></p>

<p>&nbsp; &nbsp;<strong>第八条 责任范围及责任限制</strong></p>
<p>&nbsp; &nbsp;<strong>8.1平台仅提供信息服务和技术支持服务，对本协议中列明的责任范围承担责任。平台及平台的董事、员工、代理人均不以任何明示或默示的方式对用户通过平台形成的交易及其履行提供任何担保。用户应基于自己的判断决定是否与其他用户进行交易，并自行承担交易相关的后果，与平台无关。平台在此提示，平台已经充分地向用户陈述此类责任承担问题，用户注册并使用平台的行为表明该用户已了解并接受平台关于此类责任的划分。</strong></p>
<p>&nbsp; &nbsp;<strong>8.2平台的内容可能涉及第三方网站的内容或链接（以下简称"第三方网站"）。平台不能保证也没有义务保证第三方网站上的信息的真实性和有效性。用户应按照第三方网站的协议使用第三方网站，而不是按照本协议。第三方网站的内容、产品、广告和其他任何信息均由用户自行判断并承担风险，而与平台无关。</strong></p>
<p>&nbsp; &nbsp;<strong>8.3如因不可抗力或其他平台无法控制的原因使平台系统崩溃或无法正常使用导致平台操作无法完成或丢失有关的信息、记录等，平台会合理地尽力协助处理善后事宜，平台及时向用户说明该事由的发生并提供合理证据的，平台不对因此导致的任何损害赔偿（包括但不限于利润、商誉、使用、数据等方面的损失或其他无形损失）承担责任。前述情形包括但不限于以下情形，但平台恶意或存在重大过失的情形除外：</strong></p>
<p>&nbsp; &nbsp;<strong>（1）因台风、地震、海啸、洪水、停电、战争、恐怖袭击等不可抗力因素，造成平台系统障碍不能执行业务的；</strong></p>
<p>&nbsp; &nbsp;<strong>（2）电信设备出现故障不能进行数据传输的；</strong></p>
<p>&nbsp; &nbsp;<strong>（3）由于黑客攻击、网络供应商技术调整或故障、银行方面的问题等原因而造成的平台服务中断或延迟的。</strong></p>

<p>&nbsp; &nbsp;<strong>第九条 用户信息保护及授权</strong></p>
<p>&nbsp; &nbsp;<strong>9.1平台可以根据用户在平台上的行为自动记录相关用户的某些资料，包括：在用户使用平台服务访问网页时，自动接收并记录用户浏览器和计算机上的信息，包括用户的IP地址、浏览器的类型、访问日期和时间、软硬件特征信息及用户需求的网页记录等数据。在不违反法律法规和本协议的前提下，平台有权对整个用户信息数据库进行分析并对用户数据库进行商业上的合理利用，并可在平台的某些网页上使用诸如"Cookies"的资料收集装置。除上述信息外，平台还可能为了提供服务及改进服务质量的合理需要而收集用户的其他信息，包括用户与平台客户服务团队联系时提供的相关信息，用户参与问卷调查时向平台运营方发送的问卷答复信息。与此同时，为提高用户使用平台服务的安全性，更准确地预防钓鱼网站欺诈和木马病毒，平台可能会通过了解一些用户的网络使用习惯等手段来判断用户账户的风险。对于用户操作员的个人信息保护规则，详见《隐私政策》。</strong></p>
<p>&nbsp; &nbsp;<strong>9.2用户同意，平台对于用户信息享有数据资源持有权、数据加工使用权、数据产品经营权。平台可以使用用户的相关资料，包括但不限于平台持有的有关用户的档案中的资料，以及平台通过其他方式自行收集的资料，通过人工或自动程序对用户的资料进行加工使用、评价分析等。平台的合作伙伴为提供本协议项下服务可对用户信息和资料进行查询、收集或进行信息数据分析。为确保用户信息的安全，平台及其合作伙伴将对上述信息负有保密义务，并采取各种措施保证信息安全。</strong></p>
<p>&nbsp; &nbsp;<strong>9.3平台根据法律法规的规定对用户的信息保密，平台不会披露给任何第三方，但以下情况除外：</strong></p>
<p>&nbsp; &nbsp;<strong>（1）向独立服务且仅要求服务相关的必要信息的第三方提供用户信息，如印刷厂、邮递公司等；</strong></p>
<p>&nbsp; &nbsp;<strong>（2）向具有合法调阅信息权限并从合法渠道调阅信息的司法部门或其他政府机构提供用户信息；</strong></p>
<p>&nbsp; &nbsp;<strong>（3）向经用户同意的第三方提供用户信息；</strong></p>
<p>&nbsp; &nbsp;<strong>（4）在法律规定、本协议约定及用户有效授权范围内提供用户信息。</strong></p>
<p>&nbsp; &nbsp;<strong>9.4为更好地向用户提供平台服务，用户授权并且同意运营方通过合法方式从任何第三方收集用户的额外信息，且同意平台将查询收集的用户信息进行保存、整理、加工，用于如下用途：</strong></p>
<p>&nbsp; &nbsp;<strong>（1）评价用户信用情况、核实用户信息的真实性，以更好地掌握用户情况；</strong></p>
<p>&nbsp; &nbsp;<strong>（2）创建数据分析模型，为用户度身订造或优化平台服务；</strong></p>
<p>&nbsp; &nbsp;<strong>（3）为解决用户与平台、其他用户之间的争议而将用户信息提供给法律顾问、法院、仲裁委员会和其他与争议解决有关的机构；</strong></p>
<p>&nbsp; &nbsp;<strong>（4）预防或阻止非法活动，确保用户在平台进行安全交易；</strong></p>
<p>&nbsp; &nbsp;<strong>（5）其他经用户同意的用途。</strong></p>
<p>&nbsp; &nbsp;<strong>9.5经国家生效法律文书或行政处罚决定确认用户存在违法行为，或者平台有足够事实依据可以认定用户存在违法或违反本协议的行为，平台有权在平台上公布用户的违法、违约行为。</strong></p>

<p>&nbsp; &nbsp;<strong>第十条 知识产权及其他权益保护</strong></p>
<p>&nbsp; &nbsp;10.1运营方拥有平台内容及资源的著作权等合法权利，受国家法律保护，有权对本协议、业务规则及平台的内容进行修改并发布，发布方式包括但不限于平台公告、系统消息、邮件通知、短信(含平台委托的第三方短信服务)、电话、登录提示、操作提示等。用户可以在相关服务页面查阅并确认最新版本的条款。为免疑义，该等平台内容及资源不包括用户为办理业务之目的上传的包括基础贸易合同等在内的各种资料。</p>
<p>&nbsp; &nbsp;<strong>10.2 除法律另有强制性规定外，未经平台明确的特别书面许可,任何单位不得以任何方式非法全部或部分复制、转载、引用、链接、抓取或以其他方式使用平台的信息内容，否则，平台有权追究其法律责任。</strong></p>
<p>&nbsp; &nbsp;<strong>10.3平台所刊登的资料信息（诸如文本、图表、标识、设计、源代码、图像、声音文件片段、数字下载、数据编辑和软件），均是平台或其内容提供者的财产，受中国和国际版权公约的保护。平台上所有内容的汇编（用户自身为办理业务之目的上传的包括基础贸易合同等在内的各种资料除外）是平台的排他财产，受中国和国际版权公约的保护。平台上所有软件都是平台或其关联公司或其软件供应商的财产，受中国和国际版权公约的保护。未经平台书面同意，不得将平台包含的资料（用户自身为办理业务之目的上传的包括基础贸易合同等在内的各种资料除外）等任何内容镜像到任何其他网站或者服务器。任何未经授权对平台内容的使用均属于违法行为，平台将追究其法律责任。</strong></p>
<p>&nbsp; &nbsp;<strong>10.4用户不得利用平台服务从事侵害他人权益或违法之行为，若有违反者应负所有法律责任。上述行为包括但不限于：</strong></p>
<p>&nbsp; &nbsp;<strong>（1）反对宪法所确定的基本原则，危害国家安全、泄漏国家秘密、颠覆国家政权、破坏国家统一的；</strong></p>
<p>&nbsp; &nbsp;<strong>（2）侵害他人名誉、隐私权、商业秘密、商标权、著作权、专利权、其他知识产权及其他权益；</strong></p>
<p>&nbsp; &nbsp;<strong>（3）违反依法律或合约所应负之保密义务；</strong></p>
<p>&nbsp; &nbsp;<strong>（4）冒用他人名义使用平台服务；</strong></p>
<p>&nbsp; &nbsp;<strong>（5）从事任何不法交易行为，如贩卖枪支、毒品、禁药、盗版软件或其他违禁物；</strong></p>
<p>&nbsp; &nbsp;<strong>（6）提供赌博资讯或以任何方式引诱他人参与赌博；</strong></p>
<p>&nbsp; &nbsp;<strong>（7）涉嫌洗钱、套现或进行传销活动的；</strong></p>
<p>&nbsp; &nbsp;<strong>（8）故意或重大过失从事任何可能含有电脑病毒或是可能侵害平台服务系統、资料等行为；</strong></p>
<p>&nbsp; &nbsp;<strong>（9）利用平台服务系统进行可能对互联网或移动网正常运转造成不利影响之行为；</strong></p>
<p>&nbsp; &nbsp;<strong>（10）利用平台服务上传、展示或传播虚假的、骚扰性的、中伤他人的、辱骂性的、恐吓性的、庸俗淫秽的或其他任何非法的信息资料；</strong></p>
<p>&nbsp; &nbsp;<strong>（11）使用平台提供的服务或其他电子邮件转发服务发出垃圾邮件或其他可能违反本协议的内容。</strong></p>

<p>&nbsp; &nbsp;<strong>第十一条 通知</strong></p>
<p>&nbsp; &nbsp;<strong>本协议项下的通知如以公告方式作出，一经在平台公告即视为已经送达。除此之外，其他向用户发布的具有专属性的通知将由平台向用户通过系统消息、或在注册时或者注册后变更用户信息时向平台提供的电子邮箱，或用户在注册后在平台绑定的手机发送，一经发送即视为已经送达。请用户密切关注平台的系统消息、用户的电子邮箱中的邮件和信息及手机中的短信信息等消息通知。</strong></p>

<p>&nbsp; &nbsp;<strong>第十二条 适用法律及争议解决</strong></p>
<p>&nbsp; &nbsp;<strong>12.1 本协议适用中华人民共和国大陆地区（为本协议之目的，不包括香港特别行政区、澳门特别行政区及台湾地区）现行有效的法律。如发生本协议或平台的业务规则与中华人民共和国法律相抵触，则这些内容将完全按法律规定重新解释，而其他条款则依旧保持对用户的约束力。</strong></p>
<p>&nbsp; &nbsp;<strong>12.2本协议于河南省南阳市卧龙区签署。若用户和平台就本协议的订立和履行等事宜产生争议的，用户和平台应首先协商解决；协商不成，可向本协议签署地有管辖权的人民法院起诉。如对争议进行诉讼，除争议事项或争议事项所涉及的条款外，双方应继续履行本协议项下的其它义务。</strong></p>

<p>&nbsp; &nbsp;<strong>第十三条 其他</strong></p>
<p>&nbsp; &nbsp;<strong>13.1本协议由本协议条款与平台的相关业务规则组成，本协议中未尽事宜应按照相关法律法规及平台的相关业务规则办理。</strong></p>
<p>&nbsp; &nbsp;<strong>13.2平台仅提供信息服务和技术支持服务，平台原则上不介入用户之间的交易纠纷，但可协助用户查明交易情况。</strong></p>
<p>&nbsp; &nbsp;<strong>13.3用户同意遵守《中华人民共和国民法典》、《中华人民共和国电子签名法》等相关法律法规，全面接受和履行与平台及平台其他用户在平台签订的任何电子合同，并承诺按该电子合同享有和/或放弃相应的权利、承担和/或豁免相应的义务；用户所有的签署行为已获得授权，其签署的电子合同具有法律效力。</strong></p>
<p>&nbsp; &nbsp;13.4如非特别指明，本协议条款均适用于平台所有注册用户。</p>
<p>&nbsp; &nbsp;13.5如本协议或平台规则条款中任何一条被视为废止、无效或因任何理由不可执行，该条应视为可分的且并不影响任何其他条款的有效性和可执行性。</p>
<p>&nbsp; &nbsp;<strong>13.6平台的运营方有权代表平台从事对外签署协议等相关民事行为，享有平台在本协议项下的权利并履行平台在本协议项下的义务。用户使用平台服务即视为用户已阅读并同意受本协议的约束。平台有权在必要时修改或更新本协议条款。用户可以在相关服务页面查阅最新版本的条款。</strong></p>   
  </div>
</template>

<script>
export default {
  components: {},
  data() {
    return {};
  },
  computed: {},
  watch: {},
  methods: {},
  created() {},
  mounted() {},
  activated() {},
};
</script>
<style scoped>
</style>
 <style scoped>
        body {
            font-family: "Microsoft YaHei", Arial, sans-serif;
            line-height: 1.6;
            color: #333;
            max-width: 1000px;
            margin: 0 auto;
            padding: 20px;
            background-color: #f9f9f9;
        }
        .protocol-container {
            background-color: white;
            padding: 30px;
            box-shadow: 0 0 10px rgba(0,0,0,0.1);
        }
        h1 {
            text-align: center;
            font-size: 24px;
            margin-bottom: 30px;
            color: #2c3e50;
        }
        h2 {
            font-size: 18px;
            margin: 25px 0 15px 0;
            color: #2c3e50;
            border-left: 4px solid #3498db;
            padding-left: 10px;
        }
        .protocol-header {
            text-align: right;
            margin-bottom: 30px;
        }
        .protocol-number {
            text-align: right;
            font-weight: bold;
            margin-bottom: 5px;
        }
        .update-date, .effective-date {
            text-align: right;
            margin-bottom: 5px;
            color: #666;
        }
        p {
            margin: 10px 0;
            text-indent: 2em;
        }
        .no-indent {
            text-indent: 0;
        }
        .bold {
            font-weight: bold;
        }
        .underline {
            text-decoration: underline;
        }
        .definition-list {
            margin-left: 40px;
        }
        .definition-item {
            margin-bottom: 10px;
        }
        .definition-term {
            font-weight: bold;
            display: inline;
        }
        .clause {
            margin-bottom: 5px;
        }
        .sub-clause {
            margin-left: 40px;
            margin-bottom: 5px;
        }
        .highlight {
            background-color: #f8f9fa;
            padding: 15px;
            border-left: 3px solid #e74c3c;
            margin: 15px 0;
        }
    </style>



// WEBPACK FOOTER //
// src/components/login/userAgreement.vue